/**
 * @arg {Function} callback
 * @arg {number} [wait=250] milliseconds
 * @arg {boolean} [isImmediate=false] trigger the function on the leading edge, instead of the trailing
 */
export function debounce(callback, wait=250, isImmediate=false) {
  /** @type {number | undefined} */
  let timeout;
  return /** @this {any} */ function () {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = window.setTimeout(function() {
      timeout = undefined;
      if (!isImmediate) callback.apply(context, args);
    }, wait);
    if (isImmediate && !timeout) callback.apply(context, args);
  };
}
